// custom checkout popup js 
let prodPage = document.querySelector('body.page-product')
let popupBtn = document.querySelectorAll('.customBuynow');
let popupModal = document.querySelector('#PopupModal-customCheckout');
let popupId = document.querySelector('#shopify-section-customCheckoutPopup');
popupBtn.forEach((btn)=>{
  btn.addEventListener('click', () => {
    popupModal.style.display = 'block';
    popupId.style.display = 'block';
  });
})


let customCheckoutButton = document.querySelector('.contentHolder--checkout');
let termsCheckbox = document.querySelector('.contentHolder--terms input');
customCheckoutButton.addEventListener('click', (e) => {
  e.preventDefault();
  if(prodPage && termsCheckbox.checked){
    console.log('customCheckoutButton',customCheckoutButton)
    let link = customCheckoutButton.getAttribute('link-target')
    let quantity = document.querySelector('.quantity__input.prdct_pg').value
    let finalLink = `${link}:${quantity}`;
    customCheckoutButton.setAttribute('href',finalLink)
    window.location.href = finalLink
  }else if(termsCheckbox.checked){
    window.location.href= '/checkout'
  }
});
